
import { computed, inject, useContext } from '@nuxtjs/composition-api';
import type { CheckoutDelivery } from '~/type/Checkout';
import { useUserStore } from '~/store/user';
import RadioListBlock from '~/components/RadioListBlock/index.vue';
import type { EmitteryType } from '~/plugins/emitter';
const __sfc_main = {};
__sfc_main.props = {
  list: {
    key: "list",
    required: true,
    type: Array
  },
  value: {
    key: "value",
    required: false,
    type: Number
  },
  name: {
    key: "name",
    required: false,
    type: String
  },
  emptyText: {
    key: "emptyText",
    required: false,
    type: String,
    default: 'Нет доступных способов'
  },
  deliveryView: {
    key: "deliveryView",
    required: false,
    type: Boolean,
    default: false
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const props = __props;
  const emit = __ctx.emit;
  const userStore = useUserStore();
  const context = useContext();
  const userEmail = computed(() => userStore.user?.email);
  const emitter = inject<EmitteryType>('emitter')!;
  const {
    $refiner
  } = useContext();
  function openRefiner() {
    emitter.emit('delivery-select', {
      type: 'Экспресс-доставка'
    });
    $refiner({
      type: 'showForm',
      data: {
        id: 'd14e0880-198e-11ee-a593-551a57d8a38c',
        force: true
      }
    });
    emitter.emit('express-delivery');
  }
  function getSubtext({
    period,
    price
  }: {
    period?: string;
    price?: number;
  } = {}) {
    let currentPrice;
    if (Number.isInteger(price)) currentPrice = !price ? 'Бесплатно' : `${price}₽`;
    return period && currentPrice ? `${currentPrice}, ${period}` : period || currentPrice;
  }
  function getPhoto(title: string) {
    switch (title) {
      case 'Самовывоз':
        return require('~/assets/images/checkout/pickup.svg');
      case 'Курьерская доставка 05.ru':
        return require('~/assets/images/checkout/delivery.svg');
      case 'Курьерской службой (DPD)':
        return require('~/assets/images/checkout/delivery.svg');
      case 'Экспресс-доставка*':
        return require('~/assets/images/checkout/express-delivery.svg');
      case 'Наличными при получении':
        return require('~/assets/images/cash.png');
      case 'Оплата банковской картой':
        return require('~/assets/images/card.png');
      case 'Купить в кредит (Тинькофф Банк)':
        return require('~/assets/images/calculator.png');
      case 'Наличными':
        return require('~/assets/images/cash.png');
      case 'Сбербанк.QR':
        return require('~/assets/images/sberbank.png');
      case 'Сбербанк Онлайн':
        return require('~/assets/images/sberbank.png');
      case 'Картой онлайн':
        return require('~/assets/images/payments.png');
      case 'Рассрочка':
        return require('~/assets/images/lariba.png');
    }
  }
  const radioList = computed(() => {
    return props.list.map(item => {
      return {
        name: item.title,
        value: item.id
      };
    });
  });
  function onChange(event: {
    name: string;
    value: string | number;
  }) {
    const el = props.list.find((item: CheckoutDelivery) => item.id === event.value);
    if (el) emit('change', el);
  }
  return {
    userEmail,
    openRefiner,
    getSubtext,
    getPhoto,
    radioList,
    onChange
  };
};
__sfc_main.components = Object.assign({
  RadioListBlock
}, __sfc_main.components);
export default __sfc_main;
